'use client';

import { useState, useEffect } from 'react';
import { useAccountInfo } from '@/hooks/query/account';
import dynamic from 'next/dynamic';

const NBASurveyModal = dynamic(() => import('./nba-survey-modal/nba-survey-modal').then(m => m.NBASurveyModal));

export const NBASurvey = () => {
	const { user } = useAccountInfo();
	const [showModal, setShowModal] = useState<boolean>(false);

	// 監聽 Custom Event 跳出問券
	useEffect(() => {
		const showNbaSurveyModal = ((event: CustomEvent) => {
			setShowModal(true);
		}) as EventListener;

		document.addEventListener('show-nba-survey-modal', showNbaSurveyModal);
		return () => {
			document.removeEventListener('show-nba-survey-modal', showNbaSurveyModal);
		};
	}, []);

	const isEnable = user?.LicenseeSiteSetting?.EnableNbaPlayoffsSurvey && user?.ActStatus === 2;

	return (
		isEnable ?
			<NBASurveyModal 
				showModal={showModal}
				setShowModal={setShowModal}
			/>
			: null
	);
};